var _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.356445,
    width: 31.802,
    height: 31.802,
    rx: 10.6007,
    fill: "#2165A2",
    fillOpacity: 0.2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.9008 16.155L23.0834 12.2373C22.8549 11.4857 22.3916 10.8271 21.7613 10.3582C21.1311 9.88935 20.3671 9.63484 19.5816 9.63208H12.22C11.4345 9.63484 10.6705 9.88935 10.0403 10.3582C9.41004 10.8271 8.94669 11.4857 8.71826 12.2373L15.9008 16.155Z",
    fill: "#2165A2"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.2538 17.64C16.1456 17.699 16.0243 17.7299 15.9011 17.7299C15.7779 17.7299 15.6567 17.699 15.5485 17.64L8.53955 13.8169V19.2022C8.5407 20.178 8.92887 21.1136 9.6189 21.8036C10.3089 22.4937 11.2445 22.8818 12.2203 22.883H19.5819C20.5578 22.8818 21.4933 22.4937 22.1834 21.8036C22.8734 21.1136 23.2616 20.178 23.2627 19.2022V13.8169L16.2538 17.64Z",
    fill: "#2165A2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.afaddf7e35fe6931f987f9b0dbf429cd.svg";
export { ForwardRef as ReactComponent };